import {IFormFilesInterface} from "../Shared/form-files.interface";

export type IDisabledVetSeventhSection = {
    AdditionalDocumentation?: Array<IFormFilesInterface>,
}

export const DisabledVetSeventhSectionInterface = (): IDisabledVetSeventhSection => ({
    AdditionalDocumentation: undefined
})